/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  document.addEventListener('DOMContentLoaded', function () {
    const subCollectionCards = document.querySelectorAll('.shopify-section--sub-collection .sub-collection-card');
    if(subCollectionCards.length > 1) {
        const subCollectionSlider = new Swiper('.sub-collection:not(.no-featured-collection) .sub-collections-wrapper',{
            spaceBetween: 10,
            navigation: {
                nextEl: '.shopify-section--sub-collection .swiper-button-next',
                prevEl: '.shopify-section--sub-collection .swiper-button-prev'
            },
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
              },
            breakpoints: {
                0: {
                    slidesPerView: 1.5,
                },
                424: {
                    slidesPerView: subCollectionCards.length > 2 ? 2: subCollectionCards.length
                },
                512: {
                    slidesPerView: subCollectionCards.length > 2.4 ? 2.4: subCollectionCards.length
                },
                767: {
                    slidesPerView: subCollectionCards.length > 4 ? 4: subCollectionCards.length
                },
                1024: {
                    slidesPerView: subCollectionCards.length > 2.4 ? 2.4: subCollectionCards.length
                },
                1120: {
                    slidesPerView: subCollectionCards.length > 2.7 ? 2.7: subCollectionCards.length
                },
                1200: {
                    slidesPerView: subCollectionCards.length > 3 ? 3: subCollectionCards.length
                },
                1280: {
                    slidesPerView: subCollectionCards.length > 3.6 ? 3.6: subCollectionCards.length
                },
                1366: {
                    slidesPerView: subCollectionCards.length > 3.9 ? 3.9: subCollectionCards.length,
                },
                1440: {
                    slidesPerView: subCollectionCards.length > 4 ? 4.12 : subCollectionCards.length
                }
            }
        });
        const subCollectionSliderNoFeatured = new Swiper('.sub-collection.no-featured-collection .sub-collections-wrapper',{
            spaceBetween: 10,
            navigation: {
                nextEl: '.shopify-section--sub-collection .swiper-button-next',
                prevEl: '.shopify-section--sub-collection .swiper-button-prev'
            },
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
              },
            breakpoints: {
                0: {
                    slidesPerView: 1.5,
                },
                424: {
                    slidesPerView: 1.8
                },
                512: {
                    slidesPerView: subCollectionCards.length > 2 ? 2: subCollectionCards.length
                },
                767: {
                    slidesPerView: subCollectionCards.length > 2.4 ? 2.4: subCollectionCards.length
                },
                1024: {
                    slidesPerView: subCollectionCards.length > 2.8 ? 2.8: subCollectionCards.length
                },
                1120: {
                    slidesPerView: subCollectionCards.length > 3.2 ? 3.2: subCollectionCards.length
                },
                1200: {
                    slidesPerView: subCollectionCards.length > 3.6 ? 3.6: subCollectionCards.length
                },
                1280: {
                    slidesPerView: subCollectionCards.length > 4.2 ? 4.2: subCollectionCards.length
                },
                1366: {
                    slidesPerView: subCollectionCards.length > 4.5 ? 4.5: subCollectionCards.length,
                },
                1440: {
                    slidesPerView: subCollectionCards.length > 5 ? 5: subCollectionCards.length
                }
            }
        });
        for (const [index,subCollectionCard] of subCollectionCards.entries()) {
            if(subCollectionCard.classList.contains('selected')) {
                subCollectionSlider.slideTo(index);
                break;
            }
        }
        for (const [index,subCollectionCard] of subCollectionCards.entries()) {
            if(subCollectionCard.classList.contains('selected')) {
                subCollectionSliderNoFeatured.slideTo(index);
                break;
            }
        }
    }
  })

  const href = location.href;
  const productsDataArr = [];
  const i = href.indexOf("?page=");

  if (i != -1) {
    window.location = href.substring(0, i);
  }

  let currentPageNumber = 1;

  document.addEventListener("click", (e) => {
    if (e.target.classList.contains('collection-load-more')) {
      const loadMoreButton = document.querySelector(".collection-load-more");

      let limitNumber = parseInt(loadMoreButton.getAttribute("limit"));

      const productContainer = document.querySelector(".collection__products .product-grid");

      const j = href.indexOf("/collections/");
      const _url = location.href
      ++currentPageNumber;
      const hasParams = _url.includes('?') && _url.split('?')[1].length > 0;
      let url = `${location.href.substring(j)}?page=${currentPageNumber}`;
      if(hasParams) {
        url = `${location.href.substring(j)}&page=${currentPageNumber}`;
      }
      fetch(url)
        .then((res) => res.text())
        .then((res) => {
          const parser = new DOMParser();
          const html = parser.parseFromString(res, "text/html");
          const productItems = html.querySelectorAll(".product-item");

          if (productItems.length > 0) {
            for(let i = 0; i < productItems.length; i++) {
              productContainer.appendChild(productItems[i]);
            }
            
            if (productItems.length < limitNumber) {
              loadMoreButton.style.display = "none";
            }
          }
          
        })
        .catch((err) => {
          console.log(err);
        });
    }
  })

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();

document.querySelectorAll('.lg-accordion').forEach(accordion => {
    accordion.addEventListener('toggle', function() {
      const content = accordion.querySelector('.lg-accordion__body');
      if (accordion.open) {
        content.style.maxHeight = content.scrollHeight + "px"; 
      } else {
        content.style.maxHeight = "0";
      }
    });
  });
  
  document.addEventListener('DOMContentLoaded', function () {
    scrollSlider();
  });
  
  function scrollSlider () {
    document.querySelectorAll('.scroll-slider').forEach(slider => {
        // Set the number of dots
        const numberOfDots = 4;
  
        // Create the dot container
        let scrollContainer = slider.querySelector('.scroll');
        let prevButton = slider.querySelector('.scroll_prev');
        let nextButton = slider.querySelector('.scroll_next');
        let dotsContainer = slider.querySelector('.dots-container');
  
        if (!prevButton && !nextButton) {
            slider.innerHTML += `<div class="slider-button scroll_prev hide"></div><div class="slider-button scroll_next"></div>`
        }
  
        if (!dotsContainer) {
            slider.innerHTML += `<div class="dots-container"></div>`;
        }
  
        scrollContainer = slider.querySelector('.scroll');
        prevButton = slider.querySelector('.scroll_prev');
        nextButton = slider.querySelector('.scroll_next');
        dotsContainer = slider.querySelector('.dots-container');
  
        if (scrollContainer && scrollContainer.children.length <= 0) {
            slider.style.display = "none";
        }
  
        // Determine scroll amount based on the number of dots
        const scrollAmount = scrollContainer.scrollWidth / numberOfDots;
  
        // Create dots based on the defined number of dots
        if (dotsContainer.children.length <= 0) {
            for (let i = 0; i < numberOfDots; i++) {
                const dot = document.createElement('div');
                dot.classList.add('dot');
                dot.dataset.index = i;  // Store the index in a data attribute
                dotsContainer.appendChild(dot);
            }
        }
  
        // Set initial active dot
        updateActiveDot(scrollContainer, dotsContainer);
  
        // Listen for scroll changes to update buttons and dots
        scrollContainer.addEventListener('scroll', () => {
            updateButtonsVisibility(scrollContainer, prevButton, nextButton);
            updateActiveDot(scrollContainer, dotsContainer);
        });
  
        // Activate dot on click
        dotsContainer.addEventListener('click', (e) => {
            if (e.target.classList.contains('dot')) {
                const index = parseInt(e.target.dataset.index, 10);
                const targetScrollLeft = index * scrollAmount; // Calculate the target scroll position based on index
                
                smoothScrollTo(scrollContainer, targetScrollLeft, 500, () => {
                    updateButtonsVisibility(scrollContainer, prevButton, nextButton);
                    updateActiveDot(scrollContainer, dotsContainer);
                });
            }
        });
    });
  
    document.addEventListener('click', function (e) {
        if (e.target.classList.contains('slider-button')) {
            const slider = e.target.closest('.scroll-slider');
            const scrollContainer = slider?.querySelector('.scroll');
            const prevButton = slider?.querySelector('.scroll_prev');
            const nextButton = slider?.querySelector('.scroll_next');
  
            if (scrollContainer) {
                const scrollAmount = scrollContainer.scrollWidth / 4; // Adjust based on the number of dots
                const direction = e.target.classList.contains('scroll_prev') ? -scrollAmount : scrollAmount;
  
                smoothScrollTo(scrollContainer, scrollContainer.scrollLeft + direction, 500, () => {
                    updateButtonsVisibility(scrollContainer, prevButton, nextButton);
                    updateActiveDot(scrollContainer, slider.querySelector('.dots-container'));
                });
            }
        }
    });
  }
  
  /**
  * Smooth scrolling function
  */
  function smoothScrollTo(element, target, duration, callback) {
    const start = element.scrollLeft;
    const change = target - start;
    const startTime = performance.now();
  
    function animateScroll(currentTime) {
        const elapsedTime = currentTime - startTime;
        const progress = Math.min(elapsedTime / duration, 1);
        const easeInOutQuad = progress < 0.5 
            ? 2 * progress * progress 
            : -1 + (4 - 2 * progress) * progress;
  
        element.scrollLeft = start + change * easeInOutQuad;
  
        if (elapsedTime < duration) {
            requestAnimationFrame(animateScroll);
        } else if (callback) {
            callback(); // Ensure buttons update after scrolling
        }
    }
  
    requestAnimationFrame(animateScroll);
  }
  
  /**
  * Hide or show slider buttons based on scroll position
  */
  function updateButtonsVisibility(scrollContainer, prevButton, nextButton) {
    const maxScrollLeft = scrollContainer.scrollWidth - scrollContainer.clientWidth;
  
    prevButton.classList.toggle('hide', scrollContainer.scrollLeft <= 0);
    nextButton.classList.toggle('hide', scrollContainer.scrollLeft >= maxScrollLeft);
  }
  
  /**
  * Update the active dot based on the scroll position
  */
  function updateActiveDot(scrollContainer, dotsContainer) {
    if (!scrollContainer.children.length) return;
    const slideWidth = scrollContainer.scrollWidth / dotsContainer.children.length; // Calculate based on number of dots
    const index = Math.ceil(scrollContainer.scrollLeft / slideWidth);
  
    dotsContainer.querySelectorAll('.dot').forEach((dot, i) => {
        dot.classList.toggle('active', i === index);
    });
  }

window.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.dropdown-variant__picker').forEach(picker => {
        const option_title = picker.querySelector('.dropdown_toggle');

        let soldOutText = document.querySelector('[data-sold-out-text-wrapper]').getAttribute('data-sold-out-text');

        if (!soldOutText) {
            soldOutText = "Sold out";
        }

        picker.querySelectorAll('input').forEach(input => {
            input.addEventListener('click', function (e) {
                if (option_title) {
                    if (input.classList.contains('sold-out')) {
                        option_title.querySelector('.option_title').innerHTML = `${picker.dataset.optionName} ${input.value} - ${soldOutText}`;
                    } else if (input.classList.contains('unavailable')){
                        option_title.querySelector('.option_title').innerHTML = `${picker.dataset.optionName} ${input.value} - Unavailable`;
                    } else {
                        option_title.querySelector('.option_title').innerHTML = `${picker.dataset.optionName} ${input.value}`;
                    }

                    option_title.setAttribute('data-btn-variant-id', input.dataset.valueVariantId)
                }
            })
        })
    })

    document.addEventListener('click', function (e) {
        if (e.target.classList.contains('dropdown_toggle')) {
            if (e.target.closest('.dropdown-variant__picker').classList.contains('open')) {
                e.target.closest('.dropdown-variant__picker').classList.remove('open')
            } else {
                e.target.closest('.dropdown-variant__picker').classList.add('open')
            }
        } else {
            document.querySelectorAll('.dropdown-variant__picker').forEach(picker => {
                picker.classList.remove('open')
            })
        }
    })
})

window.addEventListener('DOMContentLoaded', function () {
    limitedEditionColor();

    document.querySelectorAll('tooltip-component').forEach(tooltipComponent => {
        tooltipComponent.addEventListener('click', function () {
            limitedEditionColor();
        })
    })
})

function limitedEditionColor() {
    const productSelector = document.querySelector('.product__selectors');

    let limited_flag = false;

    if (productSelector) {
      productSelector.querySelectorAll('input').forEach(input => {
          if (input.checked && input.hasAttribute('limited')) {
              limited_flag = true;
          }
      })
    }
      
    if (limited_flag) {
        const limited_badge = document.querySelectorAll('[data-limited-edition-color]');

        limited_badge.forEach(limited_badge => {
            limited_badge.style.display = 'block'
        })
    } else {
        const limited_badge = document.querySelectorAll('[data-limited-edition-color]');

        limited_badge.forEach(limited_badge => {
            limited_badge.style.display = 'none'
        })
    }
}